exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._automation-details{min-height:100%}._automation-details .headline-2{color:#4d4d4d;font-size:18px}._automation-details .green-icon{color:#44c782}._automation-details .custom-layout{margin:0}._automation-details .row-automation{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/components/plain/userDetails/userDetails.styl
// module id = 457
// module chunks = 0